export enum PermissionsKey {
  // 🏬 Store Permissions
  ChangeStoreStatus = "change_store_status",
  CommissionStore = "commission_store",
  CreateStore = "create_store",
  UpdateStore = "update_store",
  DeleteStore = "delete_store",
  ViewStores = "view_stores",

  CreateStoreCategory = "create_store_category",
  UpdateStoreCategory = "update_store_category",
  ViewStoreCategory = "view_store_category",
  DeleteStoreCategory = "delete_store_category",

  UpdateOwner = "update_owner",
  CreateOwner = "create_owner",
  ViewOwners = "view_owners",

  ViewStoreOrders = "view_store_orders",
  UpdateOrder = "update_order",

  CreateOffer = "create_offer",
  UpdateOffer = "update_offer",
  ViewOffer = "view_offer",

  ManageTickets = "manage_tickets",

  ViewStoreTransactions = "view_store_transactions",
  StoreBalanceAction = "store_balance_action",
  ViewStoreReviews = "view_store_reviews",
  ViewStoreStats = "view_store_stats",
  ManageStoreStaff = "manage_store_staff",
  ManageBookingService = "manage_booking_service",
  ManageLaundryService = "manage_laundry_service",
  ManageLaundryOrder = "manage_laundry_order",
  ManageStoreLoginLink = "manage_store_login_link",

  CreateProduct = "create_product",
  UpdateProduct = "update_product",
  DeleteProduct = "delete_product",
  ViewProduct = "view_product",
  ManageInventory = "manage_inventory",
  ManageProductPriceApproval = "manage_product_price_approval",

  CreateStoreVariant = "create_store_Variant",
  UpdateStoreVariant = "update_store_Variant",
  ViewStoreVariant = "view_store_Variant",

  // 👤 Customer Permissions
  UpdateCustomer = "update_customer",
  DeleteCustomer = "delete_customer",
  ViewCustomerSaves = "view_customer_saves",
  ViewCustomerOrders = "view_customer_orders",
  CustomerBalanceAction = "customer_balance_action",
  ViewCustomerTransactions = "view_customer_transactions",
  ViewCustomerPointsHistory = "view_customer_points_history",
  ViewCustomerGifts = "view_customer_gifts",
  RejectGift = "reject_gift",
  ViewCustomer = "view_customer",
  ViewCart = "view_cart",

  // // Loyalty Offers
  CreateLoyaltyOffer = "create_loyalty_offer",
  UpdateLoyaltyOffer = "update_loyalty_offer",
  ViewLoyaltyOffer = "view_loyalty_offer",

  // ⚙ System Permissions
  SystemPoints = "system_points",
  SystemSettings = "system_settings",
  LandingPage = "landing_page",

  // Coupons
  CreateCoupon = "create_coupon",
  UpdateCoupon = "update_coupon",
  ViewCoupon = "view_coupon",

  // Streaks
  ManageStreak = "manage_streak",
  CreateStreak = "create_streak",
  UpdateStreak = "update_streak",
  ViewStreak = "view_streak",

  //Admin
  CreateAdmin = "create_admin",
  UpdateAdmin = "update_admin",
  ViewAdmin = "view_admin",
  ViewDashboardStats = "view_dashboard_stats",


  //Role
  CreateRole = "create_role",
  UpdateRole = "update_role",
  viewRole = "view_role",

  //Deletion
  RestoreCustomer = "restore_customer",
  RestoreOwner = "restore_owner",
  RestoreStore = "restore_store",
  deleteCustomer = "delete_customer",
  deleteOwner = "delete_owner",
  deleteStore = "delete_store",

  ManageSyestemEntities = "manage_system_entities",
  ManagePrizeWheel = "manage_prize_wheel",
  ManageContract = "manage_contract",
  SyncIntegrations = 'sync_integrations',

  ViewCustomerLoyaltyActivities = "view_customer_loyalty_activities",

  TrackOwnerActivity = "track_owner_activity",
  TrackStoreActivity = "track_store_activity",
  TrackCustomerActivity = "track_customer_activity",
  TrackAdminActivity = "track_admin_activity",

  ViewOtpHistory = "view_otp_history",

  ViewEntityAuditLogs = "View_entity_auditLogs",

  ExportCustomers = "export_customers",
  ExportOrders = "export_orders",
  ExportTransactions = "export_transactions",
  ExportStores = "export_stores",
  ExportProducts = "export_products",

  // Notifications
  SendNotifications = "send_notifications",
  ManageNotificationTemplates = "manage_notification_templates",
  ViewNotifications = "view_notifications",

  CreateOrganizer = "create_organizer",
  UpdateOrganizer = "update_organizer",
  ViewOrganizer = "view_organizer",
  CreateEvent = "create_event",
  UpdateEvent = "update_event",
  ViewEvent = "view_event",
  ManageOrganization = "manage_organization",
  ManageDonation = "manage_donation",
  ManageCampaign = "manage_campaign",
  ManageOrganizationTransactions = "manage_organization_transactions",
  ManageMerchantRegistration = "manage_merchant_registration",
}
